// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".packaging-page-container[data-v-12954e01]{position:relative}h2[data-v-12954e01]{margin-bottom:0.75rem}@media only screen and (max-width: 959px){h2[data-v-12954e01]{margin-top:3.5625rem}}.Packaging-section-content[data-v-12954e01]{margin:2.25rem 0}", ""]);
// Exports
module.exports = exports;
